import axios from "axios";
// import jwt_decode from "jwt-decode";
// import dayjs from "dayjs";

const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;

export const axiosProtected = axios.create({
  baseURL:
    `${REACT_APP_BASE_URL}` || "https://app.u-sendfulfillment.com/api/v1",
});

axiosProtected.interceptors.request.use(
  function (config) {
    const { store } = require("../../redux/store");
    const userInfo =
      store.getState().auth.loggedUser ||
      JSON.parse(localStorage.getItem("loggedUser"));
    if (userInfo?.tokens) {
      config.headers.Authorization = `Bearer ${userInfo?.tokens?.access?.token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosProtected.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // A network error has no response; reading .status of it used to throw
    if (error?.response?.status === 401) {
      // localStorage.clear();
      // localStorage.removeItem("persist:root");
      // window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosProtected;
